import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from '@/app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from '@modules/main/main.component';
import {LoginComponent} from '@modules/login/login.component';
import {HeaderComponent} from '@modules/main/header/header.component';
import {FooterComponent} from '@modules/main/footer/footer.component';
import {MenuSidebarComponent} from '@modules/main/menu-sidebar/menu-sidebar.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from '@pages/profile/profile.component';
import {
    BrowserAnimationsModule,
    provideAnimations
} from '@angular/platform-browser/animations';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {ToastrModule} from 'ngx-toastr';
import {MessagesComponent} from '@modules/main/header/messages/messages.component';
import {NotificationsComponent} from '@modules/main/header/notifications/notifications.component';

import {CommonModule, registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import {UserComponent} from '@modules/main/header/user/user.component';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {LanguageComponent} from '@modules/main/header/language/language.component';
import {MainMenuComponent} from './pages/main-menu/main-menu.component';
import {SubMenuComponent} from './pages/main-menu/sub-menu/sub-menu.component';
import {MenuItemComponent} from './components/menu-item/menu-item.component';
import {ControlSidebarComponent} from './modules/main/control-sidebar/control-sidebar.component';
import {StoreModule} from '@ngrx/store';
import {authReducer} from './store/auth/reducer';
import {uiReducer} from './store/ui/reducer';
import {ProfabricComponentsModule} from '@profabric/angular-components';
import {SidebarSearchComponent} from './components/sidebar-search/sidebar-search.component';
import {NgxGoogleAnalyticsModule} from 'ngx-google-analytics';
import {environment} from 'environments/environment';
import {MapComponent} from '@pages/map/map.component';
import {SequentialSearchComponent} from '@pages/sequential-search/sequential-search.component';
import {InnerDashboardComponent} from '@pages/inner-dashboard/inner-dashboard.component';
import {GeoPortalComponent} from '@pages/geo-portal/geo-portal.component';
import {PlanDashboardComponent} from '@pages/plan-dashboard/plan-dashboard.component';
import {ParcelDashboardComponent} from '@pages/parcel-dashboard/parcel-dashboard.component';
import {SourceMapComponent} from '@pages/source-map/source-map.component';
import {ParcelEditComponent} from '@pages/parcel-edit/parcel-edit.component';
import {EngParcelEditComponent} from '@pages/eng-parcel-edit/eng-parcel-edit.component';
import {EngPlanEditComponent} from '@pages/eng-plan-edit/eng-plan-edit.component';
import {BaladyaMapComponent} from '@pages/baladya-map/baladya-map.component';
import {GeoPortalBaladeyaComponent} from '@pages/baladya-map/geoPortalBaladeya/geo-portal-baladeya/geo-portal-baladeya.component';
import {SubSeqSearchComponent} from '@pages/sub-seq-search/sub-seq-search.component';
import {InfoBarComponent} from '@components/info-bar/info-bar.component';
import {InfoLabelComponent} from '@components/info-label/info-label.component';
import {InfoPieComponent} from '@components/info-pie/info-pie.component';
import {NavComponent} from '@components/nav/nav.component';

import {CarouselModule} from '@coreui/angular';
import {
    BaseChartDirective,
    provideCharts,
    withDefaultRegisterables
} from 'ng2-charts';
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more.src';
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {HighchartsChartModule} from 'highcharts-angular';
import {InfoGaugeComponent} from '@components/info-gauge/info-gauge.component';
import {TimeLapsComponent} from '@components/horizental-timeline/time-laps/time-laps.component';
import {HorizentalTimelineComponent} from '@components/horizental-timeline/horizental-timeline.component';
import {NgxParallaxModule, ParallaxDirective} from '@yoozly/ngx-parallax';
import {OnscrollAnimatedDirective} from './directives/onscroll/onscroll-animated.directive';
import {PageTitleComponent} from '@pages/landing-page/components/page-title/page-title.component';
import {LandingPageComponent} from '@pages/landing-page/landing-page.component';
import {
    CarouselCaptionComponent,
    CarouselComponent,
    CarouselControlComponent,
    CarouselIndicatorsComponent,
    CarouselInnerComponent,
    CarouselItemComponent 
} from '@coreui/angular';
import { ArcPercentageLableComponent } from '@components/arc-percentage-lable/arc-percentage-lable.component';
import { ArcPercentageChartComponent } from '@components/arc-percentage-chart/arc-percentage-chart.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
    declarations: [ArcPercentageLableComponent,
        HorizentalTimelineComponent,ArcPercentageChartComponent,
        TimeLapsComponent,
        InfoGaugeComponent,
        NavComponent,
        InfoPieComponent,
        InfoLabelComponent,
        InfoBarComponent,
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        ControlSidebarComponent,
        SidebarSearchComponent,
        MapComponent,
        SequentialSearchComponent,
        InnerDashboardComponent,
        GeoPortalComponent,
        PlanDashboardComponent,
        ParcelDashboardComponent,
        SourceMapComponent,
        ParcelEditComponent,
        EngParcelEditComponent,
        EngPlanEditComponent,
        BaladyaMapComponent,
        GeoPortalBaladeyaComponent,
        SubSeqSearchComponent,
        PageTitleComponent,
        LandingPageComponent
    ],
    imports: [
        CarouselModule,
        CarouselComponent,
        CarouselIndicatorsComponent,
        CarouselInnerComponent,

        CarouselItemComponent,
        CarouselCaptionComponent,
        CarouselControlComponent,
        OnscrollAnimatedDirective,
        HighchartsChartModule,
        ChartModule,
        RoundProgressModule,
        BaseChartDirective,
        FormsModule,
        ProfabricComponentsModule,
        CommonModule,
        BrowserModule,
        StoreModule.forRoot({auth: authReducer, ui: uiReducer}),
        HttpClientModule,
        AppRoutingModule,
        NgxParallaxModule,
        ReactiveFormsModule,
        CarouselModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        })
    ],
    exports: [RoundProgressModule, BaseChartDirective],
    providers: [
        provideCharts(withDefaultRegisterables()),
        {
            provide: HIGHCHARTS_MODULES,
            useFactory: () => [HighchartsMore, HighchartsSolidGauge]
        },
        provideAnimations()
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
